"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Animate_1 = require("../../Animate");

var hook_1 = __importDefault(require("./hook"));

var Loader_1 = __importDefault(require("../../Loader"));

var classnames_1 = __importDefault(require("classnames"));

exports.default = function (_a) {
  var onSuccess = _a.onSuccess,
      goToSignUp = _a.goToSignUp,
      className = _a.className,
      labelClassName = _a.labelClassName,
      inputClassName = _a.inputClassName,
      buttonClassName = _a.buttonClassName;

  var _b = hook_1.default(onSuccess),
      loading = _b.loading,
      error = _b.error,
      signIn = _b.signIn,
      emailDoesNotExist = _b.emailDoesNotExist;

  var onSubmit = function onSubmit(ev) {
    ev.preventDefault();
    signIn(ev.target.email.value, ev.target.password.value);
  };

  return react_1.default.createElement("form", {
    className: classnames_1.default('d-flex flex-column', className),
    onSubmit: onSubmit
  }, react_1.default.createElement(Animate_1.SlideInUp, {
    id: 'login-email'
  }, react_1.default.createElement("div", {
    className: 'form-group'
  }, react_1.default.createElement("label", {
    htmlFor: 'email',
    className: labelClassName
  }, "Email"), react_1.default.createElement("input", {
    autoFocus: true,
    id: 'email',
    type: 'email',
    name: 'email',
    className: classnames_1.default('form-control', inputClassName)
  }))), react_1.default.createElement(Animate_1.SlideInUp, {
    id: 'login-password'
  }, react_1.default.createElement("div", {
    className: 'form-group'
  }, react_1.default.createElement("label", {
    htmlFor: 'password',
    className: labelClassName
  }, "Password"), react_1.default.createElement("input", {
    id: 'password',
    type: 'password',
    name: 'password',
    className: classnames_1.default('form-control', inputClassName)
  })), error ? react_1.default.createElement("p", {
    className: 'text-danger mb-2'
  }, error) : '', emailDoesNotExist ? react_1.default.createElement("a", {
    className: classnames_1.default('btn mb-2'),
    onClick: goToSignUp
  }, "Sign Up?") : ''), react_1.default.createElement("div", {
    className: 'col d-md-none'
  }), react_1.default.createElement(Animate_1.FadeIn, {
    id: 'login-loader'
  }, react_1.default.createElement("button", {
    type: 'submit',
    className: classnames_1.default('btn w-100', buttonClassName),
    disabled: loading
  }, loading ? react_1.default.createElement(Loader_1.default, null) : 'Login')));
};